import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Table, Form, Button, Spinner } from 'react-bootstrap';
import Message from '../../../Components/Message';
import apiClient from '../../../AppClient';
import { CURRENCY } from '../../../constants/Constants';
import DamagesModal from './DamagesModal';
import { useNavigate } from 'react-router-dom';

const DamagesTransactions = () => {
  const navigate = useNavigate();
  const [transactions, setTransactions] = useState([]);
  const [filteredTransactions, setFilteredTransactions] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showAddModal, setShowAddModal] = useState(false);
  const [products, setProducts] = useState([]);

  useEffect(() => {
    loadTransactions();
    fetchProducts();
  }, []);

  useEffect(() => {
    filterTransactions();
  }, [searchTerm, transactions]);

  const fetchProducts = async () => {
    try {
      const response = await apiClient.get('/products/');
      setProducts(response.data);
      setError(null);
    } catch (error) {
      if (error.response) {
        setError(error.response.data.detail);
      } else {
        setError('حدث خطأ أثناء الاتصال بالسيرفر');
      }
    }
  };

  const loadTransactions = async () => {
    setIsLoading(true);
    try {
      const response = await apiClient.get('transactions/damages/');
      const data = response.data;
      setTransactions(Array.isArray(data) ? data : [data]);
      setError(null);
    } catch (error) {
      console.error('خطأ في تحميل المعاملات:', error);
      if (error.response) {
        setError(error.response.data.detail);
      } else {
        setError('حدث خطأ أثناء الاتصال بالسيرفر');
      }



    } finally {
      setIsLoading(false);
    }
  };

  const filterTransactions = () => {
    if (!searchTerm.trim()) {
      setFilteredTransactions(transactions);
      return;
    }

    const filtered = transactions.filter(transaction => {
      console.log(transaction);
      const expenseName = transaction.expense?.name.toLowerCase() || '';
      const transaction_date = transaction.transaction_date.toLowerCase() || '';
      const product = transaction.product?.name?.toLowerCase() || '';
      const expenseNotes = transaction.notes?.toLowerCase() || '';
      const expenseAmount = transaction.amount.toString().toLowerCase();
      const searchLower = searchTerm.toLowerCase();

      return (
        expenseName.includes(searchLower) ||
        product.includes(searchLower) ||
        expenseAmount.includes(searchLower) ||
        transaction_date.includes(searchLower) ||
        expenseNotes.includes(searchLower)
      );
    });

    setFilteredTransactions(filtered);
  };

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const [modalError, setModalError] = useState(null); // Add this state

  const addPayment = async (paymentData) => {
    setIsLoading(true);
    try {
      const response = await apiClient.post('/transactions/damages/add/', paymentData);
      alert('تمت الإضافة بنجاح!');
      loadTransactions();
      setShowAddModal(false);
      setError(null);
      setModalError(null); // Clear modal error on success
    } catch (error) {
      if (error.response) {
        // Set the error in the modal state instead of global state
        setModalError(error.response.data.detail);
      } else {
        setModalError('حدث خطأ أثناء الاتصال بالسيرفر');
      }
    } finally {
      setIsLoading(false);
    }
  };

  const handleSubmit = (formData, setFormError) => {
    // Process form data from the modal
    try {
      const formattedPayment = {
        ...formData,
        product: parseInt(formData.product, 10), // Changed from expense to product
        amount: parseFloat(formData.amount)
      };
      
      addPayment(formattedPayment);
    } catch (err) {
      // If there's an error during the formatting, set it in the modal
      setFormError(err.message || 'حدث خطأ أثناء معالجة البيانات');
    }
  };

  const refreshData = () => {
    loadTransactions();
  };

  const formatCurrency = (amount) => {
    return parseFloat(amount).toFixed(2);
  };

  return (
    <Container fluid className="rtl-container" dir="rtl">
      <div className="header-container bg-success text-white p-3 mb-4">
        <h1 className="h3">قائمة - الأتلاف</h1>
      </div>

      {error && <Message variant="danger">{error}</Message>}

      <div className="content-container bg-white rounded shadow p-4 mb-4">
        <Row className="mb-4">
          <Col md={6}>
            <Form.Group>
              <Form.Control
                type="text"
                placeholder="بحث..."
                value={searchTerm}
                onChange={handleSearchChange}
                dir="ltr"
                style={{ textAlign: 'right' }}
              />
            </Form.Group>
          </Col>
          <Col md={6} className="d-flex justify-content-end">
            <Button
              style={{ marginLeft: '5px' }}
              variant="outline-secondary"
              className="me-2"
              onClick={refreshData}
            >
              🔄 تحديث
            </Button>
            <Button
              variant="success"
              onClick={() => setShowAddModal(true)}
            >
              <i className="fas fa-plus"></i> إضافة عملية
            </Button>
          </Col>
        </Row>

        {isLoading ? (
          <div className="text-center py-5">
            <Spinner animation="border" variant="success" />
          </div>
        ) : filteredTransactions.length === 0 ? (
          <div className="text-center py-5">
            <div className="empty-state">
              <span className="display-4">📄</span>
              <p className="mt-3">لم ي تم العثور على معاملات</p>
            </div>
          </div>
        ) : (
          <Table responsive bordered hover>
            <thead className="bg-light">
              <tr>
                <th>ID</th>
                <th>الصنف المتضرر</th>
                <th>عدد القطع</th>
                <th>تاريخ العملية</th>
                <th>ملاحظات</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {filteredTransactions.map(transaction => (
                <tr key={transaction.id}>
                  <td>{transaction.id}</td>
                  <td>{transaction.product?.name}</td>
                  <td>{formatCurrency(transaction.amount)}</td>
                  <td>{transaction.transaction_date}</td>
                  <td>{transaction.notes}</td>
                  <td>
                    <Button variant="outline-secondary" size="sm" onClick={() => navigate(`/transactions/damages/${transaction.id}`)}>
                      <i className="fas fa-eye"></i>
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        )}
      </div>

      <DamagesModal
    show={showAddModal}
    handleClose={() => {
      setShowAddModal(false);
      setModalError(null); // Clear modal error when closing
    }}
    products={products}
    handleSubmit={handleSubmit}
    mode="add"
    apiError={modalError} // Pass the modal-specific error
  />
    </Container>
  );
};

export default DamagesTransactions;